import gql from 'graphql-tag';

import {AnalysisTemplateSelectorQuery_analysisTemplateListing_AnalysisTemplateNode as AnalysisTemplateSelectorQueryAnalysisTemplateListingAnalysisTemplateNode} from './__generated/AnalysisTemplateSelectorQuery';

export const ANALYSIS_TEMPLATE_SELECTOR_QUERY = gql`
  query AnalysisTemplateSelectorQuery @skipAudit @engComponent(name: ANALYSIS_TOOL) {
    analysisTemplateListing(excludeArchived: true) {
      ... on AnalysisTemplateNode {
        id
        name
        archiveRecord {
          purpose
        }
        configVariables {
          id
          configVariableKey
        }
        dataFrameVariables {
          id
        }
      }
    }
  }
`;

export type AnalysisTemplateSelectorTemplate =
  AnalysisTemplateSelectorQueryAnalysisTemplateListingAnalysisTemplateNode;
